export default __webpack_public_path__ + "static/media/mark3.021ebf3b.png";